import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@vectord/components';
import { useSetRecoilState } from 'recoil';

import { classPlaylistContent } from 'atoms/classPlaylistContent';
import PlaylistMarkdownContentInput from '../PlaylistMarkdownContentInput';
import PlaylistMarkdownRenderer from '../PlaylistMarkdownRenderer';
import styles from './PlaylistValidatorTabs.module.scss';

function PlaylistValidatorTabs({ playlist }) {
  const [activeTabName, setActiveTabName] = useState('edit');
  const setContent = useSetRecoilState(classPlaylistContent);
  const { article } = playlist || {};
  const { content } = article || {};

  useEffect(() => {
    setContent(content);
  }, [content, setContent]);

  return (
    <Tabs
      activeTabClassName={styles.activeTab}
      activeTabName={activeTabName}
      onChange={setActiveTabName}
      className={styles.tabs}
      headerClassName="border-bottom"
    >
      <Tab
        title="Edit"
        tabName="edit"
      >
        <PlaylistMarkdownContentInput />
      </Tab>
      <Tab
        title="Preview"
        tabName="preview"
      >
        <PlaylistMarkdownRenderer />
      </Tab>
    </Tabs>
  );
}

export default PlaylistValidatorTabs;
